import { fetchWithAuth } from '../store/fetchClient';
import { countDueRollis, type RolliDueStatus } from '../utils/rolliDue';

const isRolliDueStatus = (value: unknown): value is RolliDueStatus =>
  typeof value === 'object' && value !== null;

/** Zählt die offenen (heute fälligen oder überfälligen) Rollis eines Markts. */
export async function countFaelligeRollis(storeId: string): Promise<number> {
  const response = await fetchWithAuth(
    `/api/rollis?storeId=${encodeURIComponent(storeId)}&includeTaskMeta=1`,
  );
  if (!response.ok) {
    throw new Error('Fällige Rollis konnten nicht geladen werden.');
  }

  const payload: unknown = await response.json();
  if (!Array.isArray(payload)) {
    return 0;
  }

  return countDueRollis(payload.filter(isRolliDueStatus));
}
